// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d346911f","239":"64b1e5ed","455":"55bac9b8"}[chunkId] + ".chunk.js";
};